/* eslint-disable camelcase */
import React from 'react';
import { dateFormat, fundsTypeColorMap, fundsFromName } from 'enums';
import { typeColor } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var fundsListColumns = [{
  name: 'Номер',
  value: 'id'
}, {
  name: 'Основание',
  render: function render(_ref) {
    var from = _ref.from;
    return ___EmotionJSX("span", null, fundsFromName[from]);
  }
}, {
  name: 'Изпращач',
  value: 'sender'
}, {
  name: 'Получател',
  value: 'receiver'
}, {
  name: 'Сума',
  render: function render(_ref2) {
    var amount = _ref2.amount,
        currency = _ref2.currency,
        type = _ref2.type;
    return ___EmotionJSX("span", {
      css: typeColor(fundsTypeColorMap[type])
    }, amount, " ", currency);
  }
}, {
  name: 'Дата',
  value: 'date',
  dateTimeFormat: dateFormat
}];